import { collection, onSnapshot, query, where } from "firebase/firestore";
import { firestore } from "../../../configs/FirebaseConfig";
import useSWRSubscription from "swr/subscription";
import { FIRESTORE_ORDERS_TABLE, FIRESTORE_REGIONS_TABLE } from "../../../constants/FirestoreConstant";
import { COMPANY_COUNTRY_CODE } from "../../../constants/CompanyConstants";
import dayjs from "dayjs";

export function useOrders(maxDaysAgo = 30, customDateRange = null) {
  const { data, error } = useSWRSubscription(
    `orders-${maxDaysAgo}-${customDateRange ? `${customDateRange[0]}-${customDateRange[1]}` : "null"}`,
    (key, { next }) => {
      try {
        // Determine date range for filtering
        let startDate, endDate;

        if (customDateRange && customDateRange[0] && customDateRange[1]) {
          // Use custom date range
          startDate = dayjs(customDateRange[0]).format("YYYY-MM-DD");
          endDate = dayjs(customDateRange[1]).format("YYYY-MM-DD");
        } else {
          // Use maxDaysAgo
          startDate = dayjs().subtract(maxDaysAgo, "days").format("YYYY-MM-DD");
          endDate = dayjs().add(30, "days").format("YYYY-MM-DD"); // Include future orders
        }

        // Build Firestore query with date filtering
        const ordersQuery = query(
          collection(firestore, `${FIRESTORE_REGIONS_TABLE}/${COMPANY_COUNTRY_CODE}/${FIRESTORE_ORDERS_TABLE}`),
          where("farmorderDeliveryDate", ">=", startDate),
          where("farmorderDeliveryDate", "<=", endDate),
        );

        // Listen to orders with real-time updates
        const unsubscribeOrders = onSnapshot(
          ordersQuery,
          (snapshot) => {
            try {
              const orders = snapshot.docs.map((doc) => ({
                ...doc.data(),
                id: doc.id,
              }));

              next(null, orders);
            } catch (err) {
              next(err, null);
            }
          },
          (error) => {
            next(error, null);
          },
        );

        // Return cleanup function
        return () => {
          unsubscribeOrders();
        };
      } catch (error) {
        next(error, null);
      }
    },
  );

  return {
    data,
    error,
    loading: !data && !error,
  };
}
